/**
 * NPT-2008 — the market a site or organization sells into. Mirrors the npt-api contract:
 * admins set MarketSettings (site.market, organization.configuration.market override), the API
 * resolves DEFAULT_MARKET <- site.market <- org override and returns a Market.
 *
 * Currency is fixed to USD (Booking Holdings agreement); it is never configurable.
 */

/** ISO 3166-1 alpha-2, upper case. The allowlist itself lives in src/utils/country.util.ts. */
export type TravelerHomeCountry = 'US' | 'CA' | 'MX';

export type DistanceUnit = 'mi' | 'km';

export type MarketSettings = {
   /** Address country preselect, traveler residency default. */
   defaultCountry: TravelerHomeCountry;
   /** Phone picker default. */
   phoneDefaultCountry: TravelerHomeCountry;
   distanceUnit: DistanceUnit;
   /** Location search rerank preference, never empty. */
   searchBiasCountries: TravelerHomeCountry[];
};

export type Market = MarketSettings & { currency: 'USD' };

export const DEFAULT_MARKET: Market = {
   defaultCountry: 'US',
   phoneDefaultCountry: 'US',
   distanceUnit: 'mi',
   searchBiasCountries: ['US'],
   currency: 'USD',
};
